import { ProjectUrgency } from './project.model';

export interface Sla {
    priority: Priority;
    guaranteedReplyTime: number;
    guaranteedResponseTime: number;
    guaranteedReplyTimeNbh: number;
    guaranteedResponseTimeNbh: number;
}

export type Days = 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun';

export type PeriodId = string;

export interface Period {
    id: PeriodId;
    name: string;
    days: Days[];
    startAt: number;
    endAt: number;
    holiday: boolean;
    kind: 'response' | 'reply';
}

export interface SlaTemplate {
    id: string;
    name: string;
    sla: Sla[];
}

export enum Priority {
    URGENT = 'URGENT',
    HIGH = 'HIGH',
    NORMAL = 'NORMAL',
    LOW = 'LOW',
}

export interface ServiceLevel {
    id: string;
    urgency: ProjectUrgency;
    period: string;
}
